import { 
  Component, 
  OnInit,
  OnChanges,
  Input,
  SimpleChanges, 
  EventEmitter,
  Output,
  Inject
} from '@angular/core';

import { FatNumberStyles } from './models/widget';
import { isNil } from 'lodash-es';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { InventoryTransformations_ShellService } from './InventoryTransformations.shell.service';
import { InventoryTransformations_OperationService } from './InventoryTransformations.operation.service';
import { InventoryTransformations_DatasourceService } from './InventoryTransformations.datasource.index';
import { InventoryTransformations_FlowService } from './InventoryTransformations.flow.index';
import { InventoryTransformations_ReportService } from './InventoryTransformations.report.index';
import { InventoryTransformations_LocalizationService } from './InventoryTransformations.localization.service';
import { InventoryTransformations_total_inventory_transformation_target_material_widget_ComponentContextService } from './InventoryTransformations.total_inventory_transformation_target_material_widget.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './InventoryTransformations.frontend.types'
import { $frontendTypes as $types} from './InventoryTransformations.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'InventoryTransformations-total_inventory_transformation_target_material_widget',
  templateUrl: './InventoryTransformations.total_inventory_transformation_target_material_widget.component.html'
})
export class InventoryTransformations_total_inventory_transformation_target_material_widgetComponent extends BaseComponent implements OnInit, OnChanges {
  //#region Outputs
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  inParams: { inventory_transformation_id: number } = { inventory_transformation_id: null };
  //#region Inputs
  @Input('inventory_transformation_id') set $inParams_inventory_transformation_id(v: number) {
    this.inParams.inventory_transformation_id = v;
  }
  get $inParams_inventory_transformation_id(): number {
    return this.inParams.inventory_transformation_id;
  }
  //#endregion Inputs

  //#region Variables
  //#endregion  
  private entity: { total_packaged_amount?: number, InventoryTransformationId?: number };

  value: any;
  styles: FatNumberStyles;
  originalValue: any;
  prefix: string = '';
  suffix: string = '';

  constructor(private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: InventoryTransformations_ShellService,
private $datasources: InventoryTransformations_DatasourceService,
private $flows: InventoryTransformations_FlowService,
private $reports: InventoryTransformations_ReportService,
private $localization: InventoryTransformations_LocalizationService,
private $operations: InventoryTransformations_OperationService,
private $logger: CleanupLoggerService,
private $context: InventoryTransformations_total_inventory_transformation_target_material_widget_ComponentContextService,
) { 
    super();

    this.styles = new FatNumberStyles();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.inventory_transformation_id)) {
        this.$missingRequiredInParams.push('inventory_transformation_id');
      }
  }

  initialized = false;
  $hasDataLoaded = false;

  async $init() {

    await this.$dataLoad();

    this.initialized = true;
  }
  
  async $dataLoad() {
    const $widget = this;
    const $utils = this.$utils;

    const dsParams = {
      inventory_transformation_id:  $widget.inParams.inventory_transformation_id ,
      include_status_ids:  [3] ,
      exclude_status_ids:  null 
    };

    const data = await this.$datasources.InventoryTransformations.ds_inventory_transformation_target_lines_total_by_inventory_transformation_id.get(dsParams);
    if (isNil(data.result)) {
      this.$hasDataLoaded = false;
      this.entity = null;
    } else {
      this.$hasDataLoaded = true;
      this.entity = data.result;
      await this.$dataLoaded();
    }
  }

  async $dataLoaded() {
    const $widget = this;
    const $utils = this.$utils;

    this.value = $widget?.entity?.total_packaged_amount ?? 0;

    
    this.originalValue = $widget?.entity?.total_packaged_amount ?? 0;
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  getStyleClass() {
    const valString = isNil(this.value) ? '' : this.value.toString();
    const length = (valString).length;
    if (length === 2) {
      return 'tens';
    }
    if (length === 3) {
      return 'hundreds';
    }
    if (length === 4) {
      return 'thousands';
    }
    if (length === 5) {
      return 'tenThousands';
    }
    if (length === 6) {
      return 'hundredThousands';
    }
    if (length > 6) {
      return 'millions';
    }
    return null;
  }

}
